import { GoogleAnalytics } from '../../../_libs/analytics/google-analytics';

const sendToGoogleAnalytics = (feature, value) => {
  const eventBuilder =
    typeof wkData === 'object' ? 'Prism-Builder' : 'Prints-Builder';
  const product = typeof wkData === 'object' ? wkData.product.type : '';

  new GoogleAnalytics().sendEvent(eventBuilder, {
    event_type: feature,
    event_value: value,
    event_product: product,
    event_category: 'FeatureTracking',
    cohort: '0',
  });

  return true;
};

export default sendToGoogleAnalytics;
